module.exports = __webpack_public_path__ + "img/wifi.ce013d64.jpg";